import { render, staticRenderFns } from "./DetailInfo.vue?vue&type=template&id=cbccac08&scoped=true&"
import script from "./DetailInfo.vue?vue&type=script&lang=ts&"
export * from "./DetailInfo.vue?vue&type=script&lang=ts&"
import style0 from "./DetailInfo.vue?vue&type=style&index=0&id=cbccac08&lang=less&scoped=true&"
import style1 from "./DetailInfo.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbccac08",
  null
  
)

export default component.exports